import store from '../store';
import { EnumerationMappingUtility } from '@/services/enumeration-mapping.utility.js';

export class SKGModelConversionService {
    static getNewPropertyName(oldName) {
        const specialMappings = {
            types: 'types',
        };

        if (specialMappings[oldName]) {
            return specialMappings[oldName];
        }

        const venusProperty = store.getters['datamodel/getProperties'].find(
            (skgProp) =>
                oldName === skgProp.name && skgProp.namespace === 'venus'
        );
        const schemaProperty = store.getters['datamodel/getProperties'].find(
            (skgProp) =>
                oldName === skgProp.name && skgProp.namespace === 'schema'
        );

        return venusProperty?.fullName ?? schemaProperty?.fullName ?? null;
    }

    static getNewTypeName(oldType) {
        return store.getters['datamodel/getTypes'].find(
            (skgType) => skgType.name === oldType
        ).fullName;
    }

    static getNewTermValue(linkNameSKG, value) {
        // special case types must be mapped to "Types".
        if (linkNameSKG === 'types') {
            return SKGModelConversionService.getNewTypeName(value);
        }

        const property = store.getters['datamodel/getProperties'].find(
            (skgProp) => skgProp.fullName === linkNameSKG
        );
        if (!property) return null;

        const newValue = property.rangeIncludes?.find(
            (rI) => rI.name === value
        );

        console.log(
            `[${linkNameSKG}] mapped from [${value}] to [${
                newValue?.fullName ?? 'no match'
            }]`
        );

        if (!newValue) {
            // try to map the value using the enumeration mapping utility
            const mappedValue = EnumerationMappingUtility.map(
                value,
                property.fullName
            );
            if (mappedValue) {
                console.log(
                    `[${linkNameSKG}] mapped with CUSTOM MAPPING from [${value}] to [${mappedValue}]`
                );
                return mappedValue;
            }
        }

        if (!newValue) return null;

        console.log('matching', property);

        return newValue.fullName;
    }
}
